import { render, staticRenderFns } from "./SurveyCard.vue?vue&type=template&id=79ef028c&scoped=true&"
import script from "./SurveyCard.vue?vue&type=script&lang=js&"
export * from "./SurveyCard.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCard.vue?vue&type=style&index=0&id=79ef028c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef028c",
  null
  
)

export default component.exports